import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

export const ThirdPartiesCmp_ThirdParty_Fragment = graphql(`
  fragment ThirdPartiesCmp_ThirdParty_Fragment on ThirdParty {
    _id
    kind
    statusId
    ... on Organization {
      ...ThirdPartiesCmp_Organization_Fragment
    }
    ... on Person {
      ...ThirdPartiesCmp_Person_Fragment
    }
  }
`);

export type ThirdPartiesCmp_ThirdParty = ResultOf<
  typeof ThirdPartiesCmp_ThirdParty_Fragment
>;
